/*=========================================================================================
  File Name: store.js
  Description: Vuex store
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'

import state from "./state"
import getters from "./getters"
import mutations from "./mutations"
import actions from "./actions"

Vue.use(Vuex)

const vuexLocalStorage = new VuexPersistence({
  key: 'deltaPOS',
  storage: window.localStorage,
  reducer: state => ({
    AppActiveUser: state.AppActiveUser,
    cartItems: state.cartItems
  })
});

export default new Vuex.Store({
  getters,
  mutations,
  state,
  actions,
  plugins: [vuexLocalStorage.plugin],
  strict: process.env.NODE_ENV !== 'production'
})
